export default __webpack_public_path__ + "static/media/cross-icon.a6ecfe2d.svg";